import { postBranchGroupAssign } from '../../services/api/branchGroup.api';
import { POST_BRANCH_GROUP_ASSIGN_REQUEST, POST_BRANCH_GROUP_ASSIGN_SUCCESS, POST_BRANCH_GROUP_ASSIGN_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[POST_BRANCH_GROUP_ASSIGN_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_BRANCH_GROUP_ASSIGN_SUCCESS](state) {
			state.isLoading = false;
		},
		[POST_BRANCH_GROUP_ASSIGN_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateGroupBranchAssign({ commit }, { id, params }) {
			try {
				commit(POST_BRANCH_GROUP_ASSIGN_REQUEST);
				await postBranchGroupAssign(id, params);
				commit(POST_BRANCH_GROUP_ASSIGN_SUCCESS);
			} catch (error) {
				commit(POST_BRANCH_GROUP_ASSIGN_FAILURE, error);
			}
		},
	},
};